export class ListMyMPARequestsResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "requests",
            "baseName": "requests",
            "type": "Array<MPARequest>",
            "format": ""
        },
        {
            "name": "totalCount",
            "baseName": "totalCount",
            "type": "number",
            "format": ""
        },
        {
            "name": "nextPageToken",
            "baseName": "nextPageToken",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListMyMPARequestsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
